<!-- results-table.component.html -->
<h1 mat-dialog-title><strong>Copiar evaluaciones del </strong> nodo {{LOCAL_DATA.name}} a {{destino.estructuraNombre}} / {{destino.nombre}}  ?</h1>
<div mat-dialog-content fxLayout="column">
  <p *ngIf="evaluacionesToCopy.length==0">No existen evaluaciones para copiar, solamente es posible copiar evaluaciones en estado: Aprobado, Completo o Cerrado.</p>
  <p *ngIf="evaluacionesToCopy.length>0">Se copiaran las evaluaciones:</p>
  <mat-chip-list aria-label="Usuarios" *ngIf="evaluacionesToCopy.length>0">
    <mat-chip *ngFor="let evaluacion of evaluacionesToCopy">{{evaluacion.nombre}}</mat-chip>
  </mat-chip-list>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="doAction()" [disabled]="disableAction" *ngIf="evaluacionesToCopy.length>0">{{action | translate}}</button>
  <button mat-button (click)="closeDialog()" mat-flat-button color="warn">{{'Cancel' | translate}}</button>
</div>
